import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.CREATE_EXPORT_REQUEST,
    SUCCESS: types.CREATE_EXPORT_SUCCESS,
    FAILURE: types.CREATE_EXPORT_FAILURE,
    CANCEL: types.CREATE_EXPORT_CANCEL,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
